module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "part-i-lights-over-the-ocean"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_vm._v("Part I"), _c('br'), _vm._v(" Lights Over the Ocean")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("“When I was a little boy I lived in an old house, and")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("legend told us that a treasure was buried there…")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("it cast an enchantment over that house. My home")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("was hiding a secret in the depths of its heart…“")]), _c('br')]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("Antoine de Saint-Exupery, The Little Prince")])])]), _vm._v(" "), _c('p', [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 75
// module chunks = 0